import React from "react";
import "./PagePreloader.css";
import { SchoolLogo } from "../../assets/exports/FileExports";
const PagePreloader = ({ progress }) => {
  return (
    <div className="preloader-overlay">
      <div className="loader-content">
        <img
          fetchpriority="high"
          rel="preload"
          src={SchoolLogo}
          alt="Loading..."
          className="loading-image"
        />
        <h3 className="loading-percentage">Loading - {progress}%</h3>
      </div>
    </div>
  );
};

export default PagePreloader;
